import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static targets = ["container"]
  static values = { 
    series: Array,
    labels: Array,
    colors: Array,
    height: Number
  }

  connect() {
    this.renderChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  renderChart() {
    const options = {
      chart: {
        type: "donut",
        height: this.heightValue || 120,
        width: '100%',
        fontFamily: 'inherit',
        toolbar: {
          show: false
        }
      },
      series: this.seriesValue,
      labels: this.labelsValue,
      colors: this.colorsValue || ["#3B82F6", "#EC4899", "#10B981"],
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      plotOptions: {
        pie: {
          donut: {
            size: "65%"
          }
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: '100%'
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      tooltip: {
        theme: 'light',
        style: {
          fontSize: '12px',
          fontFamily: 'inherit'
        },
        y: {
          formatter: function(val) {
            return new Intl.NumberFormat('ja-JP').format(val) + '人'
          }
        }
      }
    }

    this.chart = new ApexCharts(this.containerTarget, options)
    this.chart.render()
  }
}